import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';

import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { FormStructureComponent } from "../components/TableProperty";
import { useNavigate } from 'react-router-dom';
import { updatedataApi, FormTextFile, PortURL } from "../components/ApiProperty";
import { LoadingIcon } from "../components/Propertyfile";
import { useSession } from '../components/SessionContext';


const GapsyEditTemplateForm = () => {
    const [formData, setFormData] = useState({});
    const [error, setError] = useState('');
    const [formStructure, setFormStructure] = useState(null);
    const [paramState, setParam] = useState('');
    const [rowID, setRowID] = useState('');
    // const [navigate, useNavigate] = useState();
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const [valueMode, setValueMode] = useState("raw");

    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'error', 'success', or 'warning'
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [notificationType, setNotificationType] = useState('IN');
    const { sessionId } = useSession();

    const department = sessionStorage.getItem("dept");
    console.log("department", department);
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get('param');
    const prefix = paramValue.split('_')[0];
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    // const urlParams = new URLSearchParams(window.location.search);
    // const params1 = urlParams.get('param');

    // Remove everything before the first underscore
    const tablenames = paramValue.substring(paramValue.indexOf('_') + 1);

    const templateFormHeading = tablenames.replace(/_/g, ' ').split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');



    const fileName = `${prefix}_${paramValue}`
    console.log("fileName", fileName);
    const activeStatus = localStorage.getItem("active_status");
    const templateType = localStorage.getItem("template_type");
    const stage = localStorage.getItem("stage");

    const apiSessionId = sessionStorage.getItem("sessionId");


    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    useEffect(() => {
        const fetchFormStructure = async () => {
            setLoading(true); // Start loading
            try {
                const rowIDValue = urlParams.get('rowIndex');
                setParam(paramValue);
                setRowID(rowIDValue);

                // const responsefromFile = await fetch(`${PortURL}/demformtemplate/${paramValue}.json`);
                const responsefromFile = await fetch(`/demformtemplate/${paramValue}.json`);
                if (!responsefromFile.ok) {
                    throw new Error('Nothing pending for Modification');
                }

                const responsetxt = await responsefromFile.json();
                console.log('Form Structure:', responsetxt);

                if (
                    responsetxt.tableName === "Finance_return_on_equity" ||
                    responsetxt.tableName === "HR_overall_saudization_rate"
                ) {
                    responsetxt.details = responsetxt.details.map(detail => {
                        const column = detail.columnName.toLowerCase();

                        // ✅ Value column → %
                        if (column === "value") {
                            return {
                                ...detail,
                                columnLabel: `${detail.columnLabel} (%)`
                            };
                        }

                        // ✅ Other specific numeric fields → Value in SAR
                        const sarFields = [
                            "annualized_net_profit",
                            "average_shareholders_equity"
                        ];

                        if (sarFields.includes(column)) {
                            return {
                                ...detail,
                                columnLabel: `${detail.columnLabel} (Value in SAR-Bn)`
                            };
                        }

                        return detail;
                    });
                }

                setFormStructure(responsetxt);

                const initialFormData = {};
                if (Array.isArray(responsetxt.details)) {
                    responsetxt.details.forEach(detail => {
                        if (detail.columnActive === "N") {
                            if (
                                !detail.columnKey ||
                                detail.columnKey.toLowerCase() === "null" ||
                                detail.columnKey.toLowerCase() === "not null"
                            ) {
                                switch (detail.columnType.toUpperCase()) {
                                    case 'INT':
                                    case 'INTEGER':
                                        initialFormData[detail.columnName] = 0; // Integer dummy value
                                        break;
                                    case 'VARCHAR':
                                    case 'CHAR':
                                    case 'TEXT':
                                        initialFormData[detail.columnName] = 'N'; // String dummy value
                                        break;
                                    case 'DATE':
                                        initialFormData[detail.columnName] = '1900-01-01'; // Default date
                                        break;
                                    default:
                                        initialFormData[detail.columnName] = null; // Unsupported types
                                }
                            }
                        } else {
                            initialFormData[detail.columnName] = '';
                        }
                    });
                } else {
                    throw new Error('Form structure is not an array.');
                }

                // ✅ Pre-calculate computed fields before setting state
                const preCalculated = calculateDynamicFields(initialFormData, responsetxt);

                // ✅ Set updated data to state
                setFormData(preCalculated);

            } catch (error) {
                console.error('Error fetching form structure:', error);
            } finally {
                setLoading(false); // End loading
            }
        };

        fetchFormStructure();
    }, [paramValue]);


    const TEMPLATE_CONFIG = {
        Finance_return_on_equity: {
            defaults: {
                frequency: "Quarterly",
                criticality: "Level 1",
                ownership: "Finance and Planning",
                risk_area: "Earnings and financial performance",
                risk_indicator: "Return on Equity (ROE)",
                definition:
                    "ROE is a financial ratio that measures the performance of the Bank based on its average shareholders' equity outstanding."
            },
            lockedFields: [
                "frequency",
                "criticality",
                "ownership",
                "risk_area",
                "risk_indicator",
                "definition"
            ],
            staticDisabledFields: [
                "annualized_net_profit",
                "average_shareholders_equity"
            ]
        },

        HR_overall_saudization_rate: {
            defaults: {
                frequency: "Quarterly",
                criticality: "Level 1",
                ownership: "Human Resources Group",
                risk_area: "People and Conduct Risk",
                risk_indicator: "Overall Saudization Rate (OSR)",
                definition:
                    "The overall Saudization rate reflects compliance with local labor regulations and the bank’s commitment to nationalization objectives."
            },
            lockedFields: [
                "frequency",
                "criticality",
                "ownership",
                "risk_area",
                "risk_indicator",
                "definition"
            ],
            staticDisabledFields: [
                "total_employees_saudi_national",
                "total_employees"
            ]
        }
    };

    // const handleValueModeChange = (mode) => {
    //     setValueMode(mode);

    //     const templateConfig = TEMPLATE_CONFIG[formStructure?.tableName];

    //     if (templateConfig) {
    //         setFormData({
    //             ...templateConfig.defaults
    //         });


    //     } else {
    //         setFormData({});
    //     }


    //     setModalMessage('');
    // };

    const handleValueModeChange = async (mode) => {
        if (!formStructure) return;

        const templateConfig = TEMPLATE_CONFIG[formStructure?.tableName];
        const valueFields = templateConfig?.staticDisabledFields || [];

        setValueMode(mode);

        // ✅ STATIC MODE
        if (mode === "static") {
            setFormData(prev => {
                const updated = { ...prev };

                valueFields.forEach(field => {
                    updated[field] = "";
                });

                return updated;
            });

            setModalMessage('');
            return;
        }

        //  RAW MODE (REFETCH + RECALCULATE)
        if (mode === "raw") {
            try {
                setLoading(true);

                const response = await fetch(`/demformtemplate/${paramValue}.json`);
                if (!response.ok) throw new Error("Failed to reload structure");

                const freshStructure = await response.json();

                setFormStructure(freshStructure);

                setFormData(prev => {
                    const recalculated = calculateDynamicFields(prev, freshStructure);
                    return recalculated;
                });

            } catch (err) {
                console.error("Error switching to raw mode:", err);
            } finally {
                setLoading(false);
            }

            setModalMessage('');
        }
    };

    useEffect(() => {
        if (formStructure && rowID) {
            fetchDataAndBindToForm();
        }
    }, [formStructure, rowID]);

    const fetchDataAndBindToForm = async () => {
        try {
            // const responseDataFile = await fetch(`${PortURL}/jsonfiles/${paramValue}_temp.json`);
            const responseDataFile = await fetch(`/jsonfiles/${paramValue}_temp.json`);
            if (!responseDataFile.ok) {
                throw new Error('Nothing pending for Modification');
            }
            const responseData = await responseDataFile.json();
            bindDataToForm(responseData, rowID);
        } catch (error) {
            console.error('Error fetching data:', error);
            setError('Failed to load data.');
        }
    };
    const handleInputChange = (columnName, value) => {
        if (!formStructure) return; // safety check

        setFormData((prevFormData) => {
            // Step 1: Update changed field
            const updatedFormData = { ...prevFormData, [columnName]: value };

            // Step 2: Recalculate computed/dynamic fields
            const recalculated = calculateDynamicFields(updatedFormData, formStructure);

            // Step 3: Return recalculated data
            return recalculated;
        });
    };



    const bindDataToForm = (data, rowID) => {
        if (!data || !formStructure) return;

        const rowData = data.find(row => String(row.rowId) === String(rowID));

        if (rowData) {
            let updatedFormStructure = [...formStructure.details];

            // Check if "Maker_Remarks" exists in rowData but not in formStructure
            if (!updatedFormStructure.some(detail => detail.columnName === "Maker_Remarks") && rowData.Maker_Remarks !== undefined) {
                updatedFormStructure.push({
                    columnName: "Maker_Remarks",
                    columnLabel: "Maker Remarks",
                    columnType: "TEXT",
                    columnActive: "Y", // Ensure it's active
                });

                // Update form structure
                setFormStructure(prevStructure => ({
                    ...prevStructure,
                    details: updatedFormStructure
                }));
            }

            // Store dataModel separately
            const dataModelValue = rowData.dataModel;

            const updatedFormData = updatedFormStructure.reduce((acc, detail) => {
                const columnName = detail.columnName;
                let value = rowData[columnName];

                if (detail.columnType.toLowerCase() === 'datetime' && value) {
                    const date = new Date(value);
                    acc[columnName] = date.toISOString().split('T')[0];
                } else {
                    acc[columnName] = value || ''; // Default to empty string if value is null/undefined
                }
                return acc;
            }, {});

            // Attach dataModel separately to formData (but don't include it in formStructure)
            updatedFormData.dataModel = dataModelValue;

            setFormData(updatedFormData);
        }
    };

    const isDateString = (val) => {
        if (typeof val !== "string") return false;
        // Matches YYYY-MM-DD, MM/DD/YYYY, or ISO-like formats
        return /^\d{4}-\d{2}-\d{2}$/.test(val) || /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val);
    };


    const calculateDynamicFields = (newFormData, formStructure) => {
        if (!formStructure) return newFormData;

        if (valueMode === "static") {
            return newFormData;
        }


        const details = formStructure.details;
        let calculatedData = { ...newFormData };

        details.forEach(detail => {
            const formula = detail.columnFunction?.trim();
            if (!formula) return;

            const columnName = detail.columnName;

            // 🚫 Skip dropdown definitions - they are not formulas
            if (formula.startsWith('dropdown:')) {
                return; // Skip processing for dropdowns
            }

            try {
                let expression = formula;

                // 🧩 1️⃣ Handle Function-style like Addition(a,b)
                const funcMatch = expression.match(/^(\w+)\s*\(([^)]*)\)$/i);
                if (funcMatch) {
                    const funcName = funcMatch[1];
                    const operands = funcMatch[2].split(',').map(o => o.trim());

                    // Resolve operand values (from form data or constants)
                    // const resolvedArgs = operands.map(op => calculatedData[op] ?? op);
                    // Resolve operand values in a case-insensitive way
                    const resolvedArgs = operands.map(op => {
                        const operandLower = op.toLowerCase();

                        // Find matching field ignoring case
                        const matchingKey = Object.keys(calculatedData).find(
                            k => k.toLowerCase() === operandLower
                        );

                        // If matched → return value
                        if (matchingKey) return calculatedData[matchingKey];

                        // Otherwise constant value or raw text
                        return op;
                    });
                    // 🔍 Validate numeric inputs before calculation
                    const hasInvalidNumber = resolvedArgs.some(arg => {
                        if (arg === null || arg === undefined || arg === "") return false;

                        // If it's already a valid number, fine
                        if (/^-?\d+(\.\d+)?$/.test(String(arg).trim())) return false;


                        // If it's a date string, allow (your existing date logic handles it)
                        if (isDateString(arg)) return false;

                        return true; // invalid numeric value detected
                    });

                    // if (hasInvalidNumber) {
                    //     setMessageType("danger");
                    //     setModalMessage("Only numeric values are allowed for calculation fields.");
                    //     return;
                    // }

                    const toNum = (x) => parseFloat(x) || 0;
                    const [a, b, c, d, e, f] = resolvedArgs.map(toNum);

                    switch (funcName.toLowerCase()) {
                        // 🧮 Math & arithmetic
                        case 'addition':
                        case 'add': {
                            const valA = resolvedArgs[0];
                            const valB = resolvedArgs[1];

                            const isDateA = isDateString(valA);
                            const isDateB = isDateString(valB);

                            if (isDateA && !isNaN(toNum(valB))) {
                                // Add days to a date
                                const d = new Date(valA);
                                d.setDate(d.getDate() + toNum(valB));
                                calculatedData[columnName] = d.toISOString();
                            } else if (!isNaN(toNum(valA)) && !isNaN(toNum(valB))) {
                                // ✅ Numeric addition
                                calculatedData[columnName] = toNum(valA) + toNum(valB);
                            } else {
                                calculatedData[columnName] = null;
                            }
                            return;
                        }

                        case 'subtraction':
                        case 'subtract': {
                            const valA = resolvedArgs[0];
                            const valB = resolvedArgs[1];

                            const isDateA = isDateString(valA);
                            const isDateB = isDateString(valB);

                            if (isDateA && isDateB) {
                                // ✅ Date difference in days
                                const diffMs = new Date(valA) - new Date(valB);
                                calculatedData[columnName] = diffMs / (1000 * 60 * 60 * 24);
                            } else if (!isNaN(toNum(valA)) && !isNaN(toNum(valB))) {
                                // ✅ Numeric subtraction
                                calculatedData[columnName] = toNum(valA) - toNum(valB);
                            } else {
                                calculatedData[columnName] = null;
                            }
                            return;
                        }


                        case 'multiplication':
                        case 'multiply':
                            calculatedData[columnName] = a * b;
                            return;
                        case 'division':
                        case 'divide': {
                            let result = b !== 0 ? a / b : 0;

                            // ✅ Multiply by 100 only for Value column in specific templates
                            if (
                                (formStructure?.tableName === "Finance_return_on_equity" ||
                                    formStructure?.tableName === "HR_overall_saudization_rate") &&
                                columnName.toLowerCase() === "value"
                            ) {
                                result = result * 100;
                                result = parseFloat(result.toFixed(2)); // ✅ Round to 2 decimals
                            }

                            calculatedData[columnName] = result;


                            return;
                        }

                        // 🕒 Date/Time-based functions
                        case 'now':
                            const now = new Date();
                            const formatted =
                                now.getFullYear() +
                                '-' +
                                String(now.getMonth() + 1).padStart(2, '0') +
                                '-' +
                                String(now.getDate()).padStart(2, '0') +
                                ' ' +
                                String(now.getHours()).padStart(2, '0') +
                                ':' +
                                String(now.getMinutes()).padStart(2, '0') +
                                ':' +
                                String(now.getSeconds()).padStart(2, '0');
                            calculatedData[columnName] = formatted;
                            return;

                        case 'year':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getFullYear();
                            return;
                        case 'month':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getMonth() + 1;
                            return;
                        case 'quarter':
                            calculatedData[columnName] = Math.floor((new Date(resolvedArgs[0]).getMonth() + 3) / 3);
                            return;
                        case 'second':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getSeconds();
                            return;
                        case 'dayofmonth':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getDate();
                            return;
                        case 'dayofweek':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getDay();
                            return;

                        case 'weeknumber': {
                            const inputDate = new Date(resolvedArgs[0]);
                            if (isNaN(inputDate)) {
                                calculatedData[columnName] = null;
                                return;
                            }

                            const target = new Date(inputDate.valueOf());
                            const dayNr = (inputDate.getDay() + 6) % 7; // Monday = 0
                            target.setDate(target.getDate() - dayNr + 3);
                            const firstThursday = new Date(target.getFullYear(), 0, 4);
                            const weekNo = 1 + Math.round(
                                ((target - firstThursday) / 86400000 - 3 + ((firstThursday.getDay() + 6) % 7)) / 7
                            );

                            calculatedData[columnName] = weekNo;
                            return;
                        }
                        case 'dayofyear': {
                            const d = new Date(resolvedArgs[0]);
                            const start = new Date(d.getFullYear(), 0, 0);
                            const diff = d - start;
                            calculatedData[columnName] = Math.floor(diff / (1000 * 60 * 60 * 24));
                            return;
                        }

                        case 'datefrommdy': {
                            const [m, dy, y] = operands.map(o => toNum(calculatedData[o]) || toNum(o));
                            calculatedData[columnName] = `${y}-${String(m).padStart(2, '0')}-${String(dy).padStart(2, '0')}`;
                            return;
                        }

                        case 'datefromyq': {
                            const [yArg, qArg] = operands;
                            const yVal = new Date(calculatedData[yArg] || yArg).getFullYear() || toNum(yArg);
                            const qVal = toNum(calculatedData[qArg]) || 1;
                            const month = (qVal - 1) * 3 + 1;
                            calculatedData[columnName] = `${yVal}-${String(month).padStart(2, '0')}-01`;
                            return;
                        }

                        default:
                            console.warn(`⚠️ Unknown operator: ${funcName}`);
                            return;
                    }
                }

                // 🧮 2️⃣ Handle direct mathematical expressions
                const fieldNames = Object.keys(calculatedData);
                fieldNames.forEach(field => {
                    const value = parseFloat(calculatedData[field]);
                    const safeValue = isNaN(value) ? 0 : value;
                    const regex = new RegExp(`\\b${field}\\b`, 'g');
                    expression = expression.replace(regex, safeValue);
                });

                if (!/^[\d+\-*/().\s]+$/.test(expression)) {
                    console.warn(`Unsafe expression skipped for ${columnName}: ${expression}`);
                    return;
                }

                // 🧠 3️⃣ Evaluate math expression safely
                // eslint-disable-next-line no-new-func
                const result = Function(`"use strict"; return (${expression})`)();
                calculatedData[columnName] = isFinite(result) ? result : 0;

            } catch (err) {
                console.error(`Error evaluating formula for ${detail.columnName}:`, err);
            }
        });

        return calculatedData;
    };


    const handleBackClick = () => {
        navigate(-1); // This navigates back to the previous page
        // navigate("/Templatetablelist"); // This navigates back to the previous page
    };

    const handleErrorClick = () => {
        // Handle the error without navigating the page
        console.log('Error occurred. Handling it without navigation.');
    };

    const handleModalClose = () => {
        if (messageType === 'success') {
            handleBackClick(); // Only navigate if success
        } else {
            setModalMessage(''); // Close modal in case of an error
            handleErrorClick(); // Handle error without navigation
        }
    };

    const handleRadioChange = (e) => {
        setNotificationType(e.target.value); // Set the selected notify option (EOD or Immediate Notify)
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = {
            ...formData,
            [name]: value
        };
        setFormData(newFormData);
        calculateDynamicFields(newFormData);
    };

    const showMessageModal = (message, type) => {
        setModalMessage(message);
        setMessageType(type);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formStructure) {
            console.error('Form structure not loaded yet.');
            return;
        }

        // ✅ Normalize form data
        const normalizedCurrentData = Object.fromEntries(
            Object.entries(formData).map(([key, value]) => [key.toLowerCase(), value])
        );

        const valueField = parseFloat(normalizedCurrentData["value"]);

        if (!isNaN(valueField) && valueField > 100) {

            if (formStructure?.tableName === "Finance_return_on_equity") {
                showMessageModal(
                    "Return on Equity (ROE) exceeds the maximum limit of 100%",
                    "danger"
                );
                return;
            }

            if (formStructure?.tableName === "HR_overall_saudization_rate") {
                showMessageModal(
                    "Overall Saudization Rate exceeds the maximum limit of 100%",
                    "danger"
                );
                return;
            }
        }

        // Get NOT NULL and PRIMARY KEY fields
        const mandatoryFields = formStructure.details.filter(detail => detail.columnKey === 'NOT NULL');
        const primaryKeyFields = formStructure.details.filter(detail => detail.columnKey === 'PRIMARY KEY');

        // 👇️ Forcefully treat Maker_Remarks as mandatory
        const allMandatoryFields = [...mandatoryFields];
        const makerRemarksField = formStructure.details.find(detail => detail.columnName === "Maker_Remarks");
        if (makerRemarksField && !allMandatoryFields.some(f => f.columnName === "Maker_Remarks")) {
            allMandatoryFields.push(makerRemarksField);
        }

        const missingMandatory = [];
        const missingPrimaryKey = [];

        for (const field of allMandatoryFields) {
            const rawValue = formData[field.columnName];
            const value = rawValue !== undefined && rawValue !== null ? String(rawValue).trim() : "";

            if (
                value === "" ||
                ["\\N", "NULL", "/N", "//N", "0"].includes(value.toUpperCase())
            ) {
                missingMandatory.push(field.columnLabel);
            }
        }

        for (const field of primaryKeyFields) {
            const rawValue = formData[field.columnName];
            const value = rawValue !== undefined && rawValue !== null ? String(rawValue).trim() : "";

            if (value === "") {
                missingPrimaryKey.push(field.columnLabel);
            }
        }

        if (missingMandatory.length > 0 || missingPrimaryKey.length > 0) {
            const missingFields = [...missingMandatory, ...missingPrimaryKey];

            const formattedFields = missingFields
                .map(field => `<span class="text-warning" style="font-size:14px; font-family:verdana">${field.toUpperCase()}</span>`)
                .join(', ');


            const message = `
        <p style="font-size:14px; color: rgba(255, 193, 7, 1); font-family:verdana; margin-bottom: 0;">
            <span style="color: rgba(255, 193, 7, 1); margin-right: 8px;">⚠️ The following fields are missing:</span>
        </p>
        <p style="font-size:14px; font-family:verdana; margin-top: 0;">
            ${formattedFields}
        </p>`;
            showMessageModal(message, 'warning');
            return;
        }

        // Proceed with valid submission
        handleNotificationSubmit();
    };

    const handleNotificationSubmit = async () => {

        try {
            const urlParam = new URLSearchParams(window.location.search);
            const paramVal = urlParam.get('param');
            console.log("paramVal", paramVal);
            const rowId = urlParam.get('rowIndex');
            const filename = tablenames + ".json"; // Example: filename can be dynamically constructed here
            // const content = JSON.stringify([formData], null, 2);
            // Create submission copy
            const submissionData = { ...formData };

            // 1️⃣ Handle static fields (disabled fields)
            if (valueMode === "static") {
                const templateConfig = TEMPLATE_CONFIG[formStructure?.tableName];
                const valueFields = templateConfig?.staticDisabledFields || [];

                valueFields.forEach(field => {
                    const columnDetail = formStructure.details.find(d => d.columnName === field);
                    if (!columnDetail) return;

                    const type = columnDetail.columnType.toUpperCase();
                    switch (type) {
                        case "INT":
                        case "INTEGER":
                        case "DECIMAL":
                        case "NUMERIC":
                        case "FLOAT":
                        case "DOUBLE":
                            submissionData[field] = 0; // numeric zero
                            break;

                        case "VARCHAR":
                        case "CHAR":
                        case "TEXT":
                            submissionData[field] = null;
                            break;

                        case "DATE":
                            submissionData[field] = null;
                            break;

                        default:
                            submissionData[field] = null;
                    }
                });
            }

            // 2️⃣ Normalize all numeric fields
            formStructure.details.forEach(detail => {
                const field = detail.columnName;
                const type = detail.columnType.toUpperCase();

                if (["INT", "INTEGER", "DECIMAL", "NUMERIC", "FLOAT", "DOUBLE"].includes(type)) {
                    if (submissionData[field] === "" || submissionData[field] === null) {
                        submissionData[field] = 0; // replace empty string with zero
                    } else {
                        submissionData[field] = Number(submissionData[field]); // ensure numeric type
                    }
                }
            });

            // 3️⃣ Prepare JSON content
            const content = JSON.stringify([submissionData], null, 2);
            console.log("Content to be sent:", content);
            console.log("formData", formData);

            // fileName is constructed correctly
            // const response = await axios.post('http://172.16.119.156:3001/form-text-file', { filename, content });
            const response = await axios.post(FormTextFile, { filename, content }, {
                headers: {
                    userId: localStorage.getItem('userid'),
                    "x-csrf-token": csrfToken
                },
                withCredentials: true,
            });
            console.log("response", response);

            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken
                },
                withCredentials: true,
                params: { "filepath": "/saswork/nas/" + filename, "rowId": rowId, "Notifications": "IN", "tableName": tablenames, "dataModel": "DEM", "dept": prefix }
            };
            // const responseDb = await axios.post('http://172.16.119.156:8081/api/updatedata/dem', {}, config);
            const responseDb = await axios.post(updatedataApi, {}, config);

            if (responseDb.data && responseDb.data.active_status && responseDb.data.template_type) {
                localStorage.setItem("active_status", responseDb.data.active_status);
                localStorage.setItem("template_type", responseDb.data.template_type);
                localStorage.setItem("stage", responseDb.data.stage);

                console.log("Stored in localStorage:", {
                    active_status: responseDb.data.active_status,
                    template_type: responseDb.data.template_type,
                    stage: responseDb.data.stage,

                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }

            if (responseDb.status === 200) {
                // Clear the form data
                const initialFormData = {};
                formStructure.details.forEach(detail => {
                    initialFormData[detail.columnName] = '';
                });
                setFormData(initialFormData);
                if (responseDb.data && responseDb.data.message) {
                    const message = responseDb.data.message;
                    if (responseDb.data.status === "success") {
                        showMessageModal(`1 record of <strong>${toTitleCase(tablenames)}</strong> Modified Successfully`, 'success'); // Show success modal in green
                        setShowModal(true);
                        setMessageType('success');
                    } else {
                        showMessageModal(message, 'error');
                        setShowModal(true);

                    }
                } else {
                    showMessageModal('Unknown error occurred', 'error'); // Fallback for unexpected cases

                }
            }
        } catch (error) {
            console.error('Error updating data:', error.message);
            showMessageModal('Error updating data', 'error'); // Show error modal in red
        }

        setShowNotificationModal(false); // Close the notification modal
    };


    const renderInput = (detail) => {
        const columnValue = formData[detail.columnName] || '';
        const isPrimaryKey = detail.columnKey === 'PRIMARY KEY';

        const commonProps = {
            className: "form-control form-control-sm",
            name: detail.columnName,
            value: columnValue,
            onChange: (e) => handleInputChange(e, detail.columnName),
        };

        switch (detail.columnType.toLowerCase()) {
            case 'datetime':
            case 'date':
                {
                    // If not a primary key, display a functional date picker
                    return (
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            value={formData[detail.columnName] ? formData[detail.columnName].split('T')[0] : ''}
                            name={detail.columnName}
                            onChange={handleChange}
                        />
                    );
                }
            case 'varchar':
                if (detail.columnFunction && detail.columnFunction.startsWith('dropdown')) {
                    const match = detail.columnFunction.match(/dropdown:\[([^\]]*)\]/);
                    const options = match && match[1] ? match[1].split(',') : [];
                    return (
                        <select {...commonProps} >
                            <option value="">--Select--</option>
                            {options.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    );
                }
                return <input type="text" {...commonProps} />;
            case 'int':
                return <input type="number" {...commonProps} />;
            default:
                return <input type="text" {...commonProps} />;
        }
    };

    if (loading) {
        return (
            <div>
                <Header />
                <LoadingIcon />
                <Footer />
            </div>
        );
    }


    if (!formStructure) {

        return (
            <div>
                <Header />
                <div className="position-absolute top-12 end-0 p-2" style={{ marginTop: '1px' }}>
                </div>
                <div>
                    <h5 className="text-center">{paramState.charAt(0).toUpperCase() + paramState.slice(1)} Form</h5>
                </div>
                <h6 className='text-center' style={{ marginTop: '40px' }}>Template form not available</h6>
                <footer className="footer fixed-bottom" style={{ padding: '0.5rem' }}></footer>
            </div>
        );
    }

    const handleDashboard = () => {
        navigate('/gapsyMdashboard');
    };

    const handleQuickEntry = () => {
        navigate('/gapsyQERejectData');
    }

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} href="#" className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2"></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <a onClick={handleQuickEntry} href="#" className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-file-earmark me-2"></i>2.1 Modify Rejected Data
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-x-circle me-2"></i>2.1.1a Modify Template Form
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <div className={`d-flex justify-content-between align-items-center mb-2 pb-1 mb-0 ${styles.borderBottom}`}>

                                                <h6>
                                                    Modify Template Form : {templateFormHeading} Form
                                                </h6>
                                                {/* {activeTab === 'manual' && ( */}
                                                <div>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm me-2 ${valueMode === "raw" ? "btn-primary" : "btn-outline-primary"}`}
                                                        onClick={() => handleValueModeChange("raw")}
                                                    >
                                                        Raw Field
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${valueMode === "static" ? "btn-primary" : "btn-outline-primary"}`}
                                                        onClick={() => handleValueModeChange("static")}
                                                    >
                                                        Actual Value
                                                    </button>
                                                </div>
                                                {/* )} */}
                                            </div>
                                            <div className="row p-2">
                                                <div style={{ maxHeight: '250px', overflowY: 'auto', width: '100%' }}>
                                                    <FormStructureComponent
                                                        paramState={tablenames}
                                                        formStructure={formStructure}
                                                        formData={formData}
                                                        handleSubmit={handleSubmit}
                                                        renderInput={renderInput}
                                                        handleInputChange={handleInputChange}
                                                        valueMode={valueMode}   // 👈 ADD THIS
                                                        templateConfig={TEMPLATE_CONFIG[formStructure?.tableName]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
            <Modal show={modalMessage} style={{ marginTop: '12vh' }}>
                <div className={`alert alert-${messageType === 'success' ? 'success' : (messageType === 'warning' ? 'warning' : 'danger aa')} alert-dismissible fade show`}
                    role="alert"
                    style={{ marginBottom: '0' }}
                >
                    <div className="align-items-center">
                        {messageType === 'success' ? (
                            <span className="me-2" style={{ color: 'green', marginBottom: "14px" }}>✅</span>
                        ) : messageType === 'error' ? (
                            <span className="me-2" style={{ color: 'red', marginBottom: "14px" }}>❌</span>
                        ) : null}

                        <p style={{
                            display: 'inline',
                            fontSize: '14px',
                            color: messageType === 'success' ? 'green' :
                                (messageType === 'warning' ? 'black' : 'red'),
                        }}

                            dangerouslySetInnerHTML={{ __html: modalMessage }} >
                        </p>
                    </div>

                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleModalClose} // Single function to handle both success and error cases
                        style={{
                            width: '15px',
                            height: '15px',
                            fontSize: '8px',
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px',
                        }}
                    ></button>
                </div>
            </Modal >
        </div>
    );
};

export default GapsyEditTemplateForm;
